import _ from "lodash"

export default {
	prepForScore(vue, rubric) {
		if (!(rubric && rubric.categories)) {
			return null
		}

		_.each(rubric.categories, cat => {
			vue.$set(cat, "response", {
				category_id: cat.id,
				score: null,
				text: null,
			})
		})
	},

	getResponse(rubric) {
		if (!(rubric && rubric.categories)) {
			return null
		}

		let response = {
			rubric_id: rubric.id,
			responses: []
		}

		_.each(rubric.categories, cat => {
			if (cat.response) {
				response.responses.push(cat.response)
			}
		})
	},

	anyScore(rubric) {
		if (!(rubric && rubric.categories)) {
			return false
		}

		for (let cat of rubric.categories) {
			if (cat.response && cat.response.score != null) {
				return true
			}
		}

		return false
	},

	anyText(rubric) {
		if (!(rubric && rubric.categories)) {
			return false
		}

		for (let cat of rubric.categories) {
			if (cat.response && cat.response.text) {
				return true
			}
		}

		return false
	},

	anyScoreOrText(rubric) {
		if (!(rubric && rubric.categories)) {
			return false
		}

		for (let cat of rubric.categories) {
			if (cat.response && (cat.response.score != null || cat.response.text)) {
				return true
			}
		}

		return false
	}
}